var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useCallback, useEffect, useState } from 'react';
import { ARROW_DOWN_KEY } from '#constants';
import { useJSPositioning } from '#hooks';
export const useContextMenu = ({ menuId, trackContextMenuOpenState, triggerElement, }) => {
    _react_refresh_temp_1();
    const [isContextMenuOpen, setIsContextMenuOpen] = useState(false);
    useEffect(() => {
        const triggerHtmlElement = triggerElement.current;
        if (triggerHtmlElement) {
            triggerHtmlElement.setAttribute('aria-expanded', String(isContextMenuOpen));
        }
    }, [isContextMenuOpen, menuId, triggerElement]);
    useEffect(() => {
        const triggerHtmlElement = triggerElement.current;
        if (triggerHtmlElement) {
            triggerHtmlElement.setAttribute('aria-haspopup', 'menu');
            triggerHtmlElement.setAttribute('aria-controls', menuId);
        }
    }, [menuId, triggerElement]);
    const { context, refs, targetProps } = useJSPositioning({
        open: isContextMenuOpen,
        placement: 'right-start',
        onOpenChange: setIsContextMenuOpen,
        strategy: 'fixed',
    });
    useEffect(() => {
        if (trackContextMenuOpenState) {
            trackContextMenuOpenState(isContextMenuOpen);
        }
    }, [isContextMenuOpen, trackContextMenuOpenState]);
    const onContextMenu = useCallback((event) => {
        event.preventDefault();
        refs.setPositionReference({
            getBoundingClientRect() {
                return {
                    width: 0,
                    height: 0,
                    x: event.clientX,
                    y: event.clientY,
                    top: event.clientY,
                    right: event.clientX,
                    bottom: event.clientY,
                    left: event.clientX,
                };
            },
        });
        setIsContextMenuOpen(true);
    }, [refs]);
    const onKeyDown = useCallback((event) => {
        if (event.key === ARROW_DOWN_KEY && event.altKey) {
            event.preventDefault();
            event.stopPropagation();
            const clientRect = event.target.getBoundingClientRect();
            refs.setPositionReference({
                getBoundingClientRect() {
                    return {
                        width: 0,
                        height: 0,
                        x: clientRect.x,
                        y: clientRect.y,
                        top: (clientRect.top + clientRect.bottom) / 2,
                        right: clientRect.right,
                        bottom: clientRect.bottom,
                        left: (clientRect.left + clientRect.right) / 2,
                    };
                },
            });
            setIsContextMenuOpen(true);
        }
    }, [refs]);
    useEffect(() => {
        const trigger = triggerElement?.current;
        trigger?.addEventListener('contextmenu', onContextMenu);
        trigger?.addEventListener('keydown', onKeyDown);
        return () => {
            trigger?.removeEventListener('contextmenu', onContextMenu);
            trigger?.removeEventListener('keydown', onKeyDown);
        };
    }, [onContextMenu, onKeyDown, refs, triggerElement]);
    return { context, targetProps, isContextMenuOpen, setIsContextMenuOpen };
};
_react_refresh_temp_1(useContextMenu, "artLAQJRDxlM04mzTKSEkW+l0a4=", false, () => [useJSPositioning]);
